import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Card } from "@/components/ui/card";
import { ChartType1 } from "./chart-type-1";
import { GenericType } from "@/types";

export const DashboardTable = ({
  data,
  isAdmin,
}: {
  data: GenericType;
  isAdmin: boolean;
}) => {
  return (
    <Card className="rounded-md overflow-hidden">
      <div className="max-h-[400px] overflow-y-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-100  sticky top-0 text-slate-700 z-[9]">
              {isAdmin ? (
                <th className="text-left font-normal py-3 px-5">Company</th>
              ) : null}

              <th className="text-center font-normal  py-2 px-5">
                <span
                  style={{
                    display: "inline-block",
                    width: "100px",
                  }}
                >
                  Total Processed Files
                </span>
              </th>
              <th className="text-center font-normal  py-2 px-5">
                Snc <br />
                Success
              </th>
              <th className="text-center font-normal  py-2 px-5">
                Erp <br />
                Success
              </th>
              <th className="text-center font-normal  py-2 px-5">
                Erp <br />
                Failed
              </th>
              <th className="text-center font-normal  py-2 px-5">
                On <br />
                Hold
              </th>
              <th className="text-center font-normal  py-2 px-5">
                Validation <br />
                Failed
              </th>
              <th className="text-center font-normal  py-2 px-5">Failed</th>
              <th className="text-center font-normal  py-2 px-5">Duplicate</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row: GenericType, index: number) => {
              // const graph = {
              //   processed: row.processed,
              //   failed: row.failed,
              //   erp_processed: row.erp_processed,
              //   erp_failed: row.erp_failed,
              // };
              return (
                <tr key={index} className="even:bg-gray-50">
                  {isAdmin ? (
                    <td className=" py-2 px-5 text-slate-500">
                      {row.company_id}
                    </td>
                  ) : null}

                  <td className=" py-3 px-5 text-center ">
                    <ConditionRenderer
                      condition={row.total_processed_files ? true : false}
                    >
                      <span className="w-[63px] bg-slate-100 border-slate-300 text-slate-500 border inline-block rounded-full text-center">
                        {row.total_processed_files || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer
                      condition={row.snc_success ? true : false}
                    >
                      <span className="w-[63px] bg-blue-100 border-blue-300 text-blue-500 border inline-block rounded-full text-center">
                        {row.snc_success || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer
                      condition={row.erp_success ? true : false}
                    >
                      <span className="w-[63px] bg-green-100 border-green-300 text-green-500 border inline-block rounded-full text-center">
                        {row.erp_success || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer
                      condition={row.erp_failed ? true : false}
                    >
                      <span className="w-[63px] bg-red-100 border-red-300 text-red-500 border inline-block rounded-full text-center">
                        {row?.erp_failed || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer condition={row.on_hold ? true : false}>
                      <span className="w-[63px] bg-orange-100 border-orange-300 text-orange-500 border inline-block rounded-full text-center">
                        {row?.on_hold || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer
                      condition={row.validation_failed ? true : false}
                    >
                      <span className="w-[63px] bg-red-100 border-red-300 text-red-500 border inline-block rounded-full text-center">
                        {row?.validation_failed || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer condition={row.failed ? true : false}>
                      <span className="w-[63px] bg-red-100 border-red-300 text-red-500 border inline-block rounded-full text-center">
                        {row?.failed || 0}
                      </span>
                    </ConditionRenderer>
                  </td>
                  <td className=" py-2 px-5 text-center">
                    <ConditionRenderer condition={row.duplicate ? true : false}>
                      <span className="w-[63px] bg-orange-100 border-orange-300 text-orange-500 border inline-block rounded-full text-center">
                        {row?.duplicate || 0}
                      </span>
                    </ConditionRenderer>
                  </td>

                  <td>
                    <ChartType1
                      total_processed_files={row.total_processed_files || 0}
                      snc_success={row.snc_success || 0}
                      erp_success={row.erp_success || 0}
                      erp_failed={row.erp_failed || 0}
                      on_hold={row.on_hold || 0}
                      validation_failed={row.validation_failed || 0}
                      failed={row.failed || 0}
                      duplicate={row.duplicate || 0}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
